var _style, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCufflinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st56{fill:#FFFFFF;stroke:#010101;stroke-width:2.9252;stroke-miterlimit:10;}\n\t.st55{fill:#FFFFFF;stroke:#010101;stroke-width:0.7313;stroke-miterlimit:10;stroke-dasharray:2.9252;}\n\t.st54{fill:#FFFFFF;stroke:#010101;stroke-width:0.9751;stroke-miterlimit:10;stroke-dasharray:2.9252;}\n\t.st53{fill:#010101;}\n\t.st52{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 181.97,
    className: "st56",
    width: 302.27,
    height: 180.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 126.03,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 484.421 60.1516)",
    className: "st55",
    width: 170.88,
    height: 292.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.65,
    y: 171.59,
    transform: "matrix(0.9995 -0.0301 0.0301 0.9995 -7.7778 6.5764)",
    className: "st56",
    width: 302.27,
    height: 180.63
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.52,
    y: 176.47,
    transform: "matrix(-0.9995 0.0301 -0.0301 -0.9995 437.3412 517.2399)",
    className: "st54",
    width: 292.52,
    height: 170.88
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.12,
    y: 266.55,
    transform: "matrix(0.9976 -0.0689 0.0689 0.9976 -18.2559 7.7149)",
    className: "st53",
    width: 45.1,
    height: 3.73
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st53",
    cx: 102.68,
    cy: 268.42,
    r: 19.59
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66.65,
    y: 174.91,
    transform: "matrix(0.9995 -0.0301 0.0301 0.9995 -5.3759 6.4559)",
    className: "st52",
    width: 290.67,
    height: 14.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCufflinks);
export default __webpack_public_path__ + "static/media/CUFFLINKS.93579f8050bd9b50572c6859fb0fc43a.svg";
export { ForwardRef as ReactComponent };